import { Component, EventEmitter, Input, Output } from "@angular/core";
import { scaleLog } from "d3";

@Component({
  selector: "app-zoom-level",
  templateUrl: "./zoom-level.component.html",
  styleUrls: ["./zoom-level.component.scss"],
})
export class ZoomLevelComponent {

  @Input()
  public min: number = 0.1;
  @Input()
  public max: number = 10;

  private _zoomLevel: number;
  public get zoomLevel(): number {
    return this._zoomLevel;
  }
  @Input()
  public set zoomLevel(value: number) {
    if (value === this.zoomLevel) {
      return;
    }

    this._zoomLevel = value;
    this.zoomLevelChange.emit(this.zoomLevel);
  }
  @Output()
  public zoomLevelChange: EventEmitter<number> = new EventEmitter<number>();

  public get linearZoom(): number {
    return this.scale(this.zoomLevel);
  }

  public set linearZoom(value: number) {
    this.zoomLevel = this.scale.invert(value);
  }

  public readonly minLinear: number = 1;
  public readonly maxLinear: number = 100;
  private scale = scaleLog()
    .base(Math.E)
    .domain([this.min, this.max])
    .range([this.minLinear, this.maxLinear]);

  constructor() {
  }
}
